import { FileSignature } from "lucide-react";
import type { Block } from "@/types/proposals";

interface SignatureBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  onSelect: () => void;
}

export function SignatureBlock({ block, onSelect }: SignatureBlockProps) {
  const { label } = block.content;

  return (
    <div className="cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all rounded p-6 border-2 border-dashed" onClick={onSelect}>
      <div className="space-y-4">
        <p className="font-semibold">{label || "Signature"}</p>
        <div className="h-32 bg-muted/50 rounded flex items-center justify-center">
          <FileSignature className="w-8 h-8 text-muted-foreground opacity-50" />
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground">Name:</p>
            <div className="h-8 border-b border-muted-foreground/20 mt-1" />
          </div>
          <div>
            <p className="text-muted-foreground">Date:</p>
            <div className="h-8 border-b border-muted-foreground/20 mt-1" />
          </div>
        </div>
      </div>
    </div>
  );
}
